//Environment Specific Config
let config = module.exports = {};

config.env = 'development';
config.port = '3000';
config.host = 'http://devfpp.uplyftcapital.com:' + config.port;

//API URL
config.apiUrl = 'http://devcrm.uplyftcapital.com:3210';